import React, { Fragment } from "react";
import Label from "lib/Label";
import DynamicForm from "components/DynamicForm";

const DocumentsMapper = (props) => {
  const { selectedData, title, form_field_items, input_fields, custom_styles } =
    props;

  const array = selectedData?.[form_field_items] || [];
  return (
    <>
      {title && title.length ? (
        <Label label={title} className="view_card_label" />
      ) : (
        ""
      )}

       {array?.map((data, i) => (
          <Fragment key={i}>
            {input_fields.map((item, index) => {
              return (
                <Fragment key={index}>
                  {item?.type ? (
                    <Fragment key={index}>
                      <DynamicForm
                        formFields={item}
                        isMapper={true}
                        selectedData={selectedData}
                        documentData={data}
                        form_field_items={form_field_items}
                      />
                    </Fragment>
                  ) : null}
                </Fragment>
              );
            })}
          </Fragment>
        ))}
    </>
  );
};

export default DocumentsMapper;
